<template>
	<div>
		<Layout>
			<div class="login-container" tabscope>
				<div class="login-card">
					<div class="form-section">
						<form class="form-box" v-on:submit="submit">
							<div class="form-header">
								<div class="form-title">{{ $t('login.f.login-to-app') }}</div>
								<div class="form-description">{{ $t('login.f.enter-package-code') }}</div>
							</div>
							<div class="form-fields">
								<div class="field-container">

									<div class="field username">
										<nk-input :options="customerCodeOptions" autofocus v-model="customerDetails.customerCode" startup tabindex="101"></nk-input>
										<icon class="placeholder-icon" name="user-tag" group="light" />
									</div>
								</div>
							</div>
							<div class="buttons">
								<button @click="submit" v-if="!spinning" tabindex="102" type="submit">{{ $t('login.buttons.submit') }}
								</button>
								<div v-else class="sk-chase">
									<div class="sk-chase-dot"></div>
									<div class="sk-chase-dot"></div>
									<div class="sk-chase-dot"></div>
									<div class="sk-chase-dot"></div>
								</div>
							</div>
						</form>
					</div>
					<div class="business-section">
						<div class="nikan-logo-container">
							<img class="h-100 w-100" src="../../assets/logo-white.png" />
						</div>
						<div class="business-details">
							<div class="business-name">
								{{ $t('login.f.image-title') }}
							</div>
							<div class="business-description">
								<div class="business-nikan">{{ $t('login.f.nikan') }}</div>
								<div> {{ $t('login.f.business-description') }}</div>
							</div>
						</div>
						<div class="business-apps">
							<InfiniteScroller :items="businessItems"></InfiniteScroller>
						</div>
					</div>
				</div>
			</div>
		</Layout>
	</div>
</template>

<script>
	import _ from 'lodash'
	import Layout from '~/views/shared/_layout-login'
	import TabOrder from '~/statics/taborder-functions'
	import validators, { Checker, VEqual, VLength, isEmpty } from '~/statics/validators'
	import { post } from '~/plugins/nikan-api'
	import Endpoints from '@nikan/endpoints'
	import { mapActions } from 'vuex'
	import router from '~/plugins/router'
	import InfiniteScroller from '@/components/Infinite-scroller/Infinite-scroller.vue'
	import logoPakhsh from '@/assets/app-logos/app-pakhsh.webp'
	import logoTolid from '@/assets/app-logos/app-tolid.webp'
	import logoBazargani from '@/assets/app-logos/app-bazargani.webp'
	import logoPeyman from '@/assets/app-logos/app-peyman.webp'
	import logoSandugh from '@/assets/app-logos/app-sandugh.webp'

	export default {
		components: {
			Layout,
			InfiniteScroller
		},
		data() {
			return {
				isCaptchaEnabled: import.meta.env.VITE_CAPTCHA_STATUS === 'enabled',
				message: null,
				spinning: false,
				customerDetails: {
					customerCode: null,
					recaptchaToken: '',
				},
				validateButtonOptions: {
					title: this.$t('install.buttons.checkAndContinue'),
					isPrimary: true,
				},
				captchaSiteKey: import.meta.env.VITE_CAPTCHA_SITE_KEY,
				customerCodeOptions: {
					mode: 'string',
					ltr: true,
					placeholder: this.$t('install.customerValidation.f.customerCode')
				},
				validators: {
					customerCode: validators('required'),
				}
			}
		},
		computed: {
			businessItems() {
				return [
					{ link: '#', title: this.$t('login.apps.distribution'), image: logoPakhsh },
					{ link: '#', title: this.$t('login.apps.manufacturing'), image: logoTolid },
					{ link: '#', title: this.$t('login.apps.commerce'), image: logoBazargani },
					{ link: '#', title: this.$t('login.apps.contracting'), image: logoPeyman },
					{ link: '#', title: this.$t('login.apps.fund'), image: logoSandugh },
				]
			}
		},
		created() {
			let nikanUser = window.localStorage.getItem('nikan-user') ? (JSON.parse(window.localStorage.getItem('nikan-user'))?.useraccount) : ''
			this.customerDetails.customerCode = nikanUser?.customerCode || ''
		},
		methods: {
			...mapActions('useraccount', ['applyDetails']),
			submit(button, e) {
				if (this.validateInputs()) {
					this.spinning = true
					let data = { customerCode: this.customerDetails.customerCode, RT: this.customerDetails.recaptchaToken }
					post(Endpoints.getUrl('launcher.status'), data, null, { ignoreCommercialAccess: true, silent: true }).then((res) => {
						this.spinning = false
						this.applyDetails({ customerCode: this.customerDetails.customerCode })
						this.cache_clear()
						router.push({ name: 'install' })
					}).catch(err => {
						this.spinning = false
						let message = err.exception.response.data.errors[0].description
						if (message == 'Migration Required') {
							this.applyDetails({ customerCode: this.customerDetails.customerCode })
							router.push({ name: 'migration' })
						} else {
							this.$toast(message, { type: 'error' })
						}
					})
				}

			},

			validateInputs() {
				let checker = new Checker((field) => this.$t(`install.customer.f.${field}`))
				let errors = checker.test(this.customerDetails, this.validators)

				if (this.isCaptchaEnabled && !this.customerDetails.recaptchaToken.length) {
					errors.push({ key: 'install', error: this.$t('install.m.captcha') })
				}

				this.validationToast(errors)
				return errors.length === 0
			},
			customerCodeChanged(val) {
				this.customerDetails.customerCode = val
			},
			subscribeKeys() {
				TabOrder.subscribeKeys('install', this)
			},
		},
	}
</script>

<style lang="less" src="~/styles/login.less"></style>
